import { usePath } from "../libs/path/PathProvider"
import GTextField from "../libs/textfield/GTextField"

export function useSearchFilter(){
    const {query} = usePath()
    return query.search as string || ""
}

export default function SearchFilter(){
    const {setQuery} = usePath()
    const search = useSearchFilter()
    const onFilter = (e:any) => setQuery({search:e.target.value.toUpperCase()})
    return <GTextField className="search flex1" value={search} onChange={onFilter} placeholder="Search" type="search"/>
}